import { Box, Typography } from '@mui/material';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { sampleSetInterpretiveReportsQueryOptions } from '../../../../../../services/queries';

export const Route = createFileRoute(
  '/_authenticated/_navbar/experiments/$sampleSetId/reports/'
)({
  beforeLoad: async ({ context, params }) => {
    const reports = await context.queryClient.ensureQueryData(
      sampleSetInterpretiveReportsQueryOptions(
        params.sampleSetId,
        context.auth.hasPermission
      )
    );

    const newestReport = [...reports.data].sort(
      (a, b) =>
        new Date(b.created_date).getTime() - new Date(a.created_date).getTime()
    )[0];

    if (newestReport) {
      throw redirect({
        to: '/experiments/$sampleSetId/reports/$reportId',
        params: { sampleSetId: params.sampleSetId, reportId: newestReport.id },
        search: true,
        replace: true,
      });
    }
  },
  // Should only occur if the user manually visits the path with no reports
  component: NoReportsRoute,
});

function NoReportsRoute() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 200,
      }}
    >
      <Typography variant="body1" sx={{ color: 'text.secondary' }}>
        No reports for this sample set yet.
      </Typography>
    </Box>
  );
}
